// extracted by mini-css-extract-plugin
module.exports = {"main":"article_main__w_SGl","related-wrapper":"article_related-wrapper__FLzxV","grecaptcha-badge":"article_grecaptcha-badge__tAktv","hasSearch":"article_hasSearch__au3BJ"};